if (!customElements.get("m-benefits-bar")) {
  class MBenefitsBar extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector(".m-benefits-bar__list");
      this.controls = this.querySelector(".m-benefits-bar__controls");
      if (!this.list || !this.controls) return;

      this.prevButton = this.controls.querySelector(".m-slider-controls__button-prev");
      this.nextButton = this.controls.querySelector(".m-slider-controls__button-next");
      if (!this.prevButton || !this.nextButton) return;

      this.update = this.update.bind(this);

      this.prevButton.addEventListener("click", () => this.step(-1));
      this.nextButton.addEventListener("click", () => this.step(1));
      this.list.addEventListener("scroll", this.update, { passive: true });

      if ("ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.list);
      } else {
        window.addEventListener("resize", this.update);
      }

      this.onBlockSelect = this.onBlockSelect.bind(this);
      document.addEventListener("shopify:block:select", this.onBlockSelect);

      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener("resize", this.update);
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }

    get stepSize() {
      const item = this.list.querySelector(".m-benefits-bar__item");
      if (!item) return this.list.clientWidth;
      const styles = getComputedStyle(this.list);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    step(direction) {
      this.list.scrollBy({ left: this.stepSize * direction, behavior: "smooth" });
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;
      this.list.scrollTo({ left: event.target.offsetLeft - this.list.offsetLeft, behavior: "smooth" });
    }

    update() {
      // Só há o que navegar quando a lista realmente transborda (mobile).
      const maxScroll = this.list.scrollWidth - this.list.clientWidth;
      this.controls.classList.toggle("is-hidden", maxScroll <= 1);

      const position = this.list.scrollLeft;
      this.prevButton.toggleAttribute("disabled", position <= 1);
      this.nextButton.toggleAttribute("disabled", position >= maxScroll - 1);
    }
  }

  customElements.define("m-benefits-bar", MBenefitsBar);
}
